import {produce} from 'immer'

import toPath from 'lodash/toPath'

import {useMatrixParamBuildContext} from '../contexts/MatrixParamBuildContext'
import {useMatrixParamBuildError} from '../contexts/MatrixParamBuildErrorContext'
import type {MatrixParamBuildValues} from '../MatrixParamBuild.types'

function useMatrixParamBuildFieldControl(fieldName: string) {
  const fieldPath = toPath(fieldName)
  const {parameters, buildTypeId, setParameters} = useMatrixParamBuildContext()
  const {fieldErrorMessage, setHideErrorHandler, ...restContext} = useMatrixParamBuildError()
  const errorMessage = fieldErrorMessage[fieldName]
  const isFieldTouched = fieldName in fieldErrorMessage
  const changeValueHandler = (value: MatrixParamBuildValues) => {
    const [pathParameterIndex, _, valueIndex] = fieldPath
    const parameterIndex = Number(pathParameterIndex)
    const parameter = parameters[parameterIndex]

    if (parameter) {
      setParameters(state =>
        produce(state, draft => {
          const draftParameter = draft[parameterIndex]

          if (draftParameter?.value != null) {
            const newParameterValues = draftParameter.value

            newParameterValues[Number(valueIndex)] = value

            draftParameter.value = newParameterValues
          }
        }),
      )
    }
  }
  const changeParameterHandler = (name: string) => {
    const [index] = fieldPath
    const parameter = parameters[Number(index)]

    if (parameter) {
      setParameters(state =>
        produce(state, draft => {
          draft[Number(index)] = {...parameter, name}
        }),
      )
    }
  }

  return {
    errorMessage,
    isFieldTouched,
    buildTypeId,
    changeValueHandler,
    changeParameterHandler,
    setHideErrorHandler,
    ...restContext,
  }
}

export default useMatrixParamBuildFieldControl
